<template>
    <tr class="center aligned" :class="{ error: status == 'canceled' }">
        <td>
            {{ driver.name }}
        </td>
        <td>
            {{ human_datetime(begin_at) }}
        </td>
        <td>
            {{ human_datetime(end_at) }}
        </td>
        <td>
            <div v-if="status == 'waiting'">
                <i class="wait large icon"></i>
                    <!-- 準備 -->
                    {{ $t('ui.general.ready') }}
            </div>
            <div v-if="status == 'processing'">
                <i class="notched circle loading large icon"></i>
                <!-- 處理中... -->
                {{ $t('ui.general.handling') }}
            </div>
            <div v-if="status == 'done'">
                <i class="check large icon"></i>
                <!-- 完成 -->
                {{ $t('ui.general.success') }}
            </div>
            <div v-if="status == 'failed'">
                <i class="remove large icon"></i>
                <!-- 失敗 -->
                {{ $t('ui.general.failure') }}
            </div>
            <div v-if="status == 'canceled'">
                <i class="remove large icon"></i>
                {{ $t('ui.general.cancel') }}
            </div>
        </td>
        <td class="left aligned">
            <router-link
                :to="{name: 'driver_commission_report', params: {identity: report_identity}}"
                class="ui basic primary button"
                v-if="status == 'done'"
                target="_blank"
            >
                <!-- 前往報告 -->
                {{ $t('ui.pages.driver_commission_reports.go_to_report') }}
            </router-link>
            <div class="ui basic negative button" v-if="status == 'failed'" @click.prevent="cancel">
                {{ $t('ui.general.cancel') }}
            </div>
            <div class="ui basic disabled negative button" v-if="status != 'failed' && status != 'done'">
                {{ $t('ui.general.cancel') }}
            </div>
        </td>
    </tr>
</template>

<script>
import moment from 'moment'
export default {
    name: "ProviderDriverCommissionReportsNewItem",
    props: {
        driver: Object,
        begin_at: String,
        end_at: String,
    },
    data() {
        return {
            status: "waiting",
            report_identity: null,
            errors: [],
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
        cancel() {
            // this.$parent.selected_driver_identities = _.filter(
            //     this.$parent.selected_driver_identities,
            //     (e) => { return e != this.driver.identity }
            // );
            this.status = "canceled"
        },
        human_datetime(data) {
            if (!data || data == 'Invalid date') {
                // 尚未選擇
                return this.$t('ui.pages.driver_commission_reports.no_select_date');
            } else {
                return moment(data).locale(
                    this.$store.state.language || "zh-tw"
                ).format("lll");
            }
        },
    },
    components: {
    }
}
</script>
